import { EventRepository } from '~repositories/EventRepository';
import serviceNames from '~setup/AnalyticsService';
import { diContainer } from '~setup/diContainer';
import { Event } from '~entities/Event';

export interface IVtoAction {
    event: string;
    vtoType: string;
    eventValue?: number;
    vtoItemId?: string;
    vtoLookIndex?: number;
    vtoLookId?: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    vtoBrowGoals?: any[];
    vtoBrowShape?: string;
    vtoBrowSkuId?: string;
    vtoBrowLength?: string;
    vtoBrowThickness?: string;
    vtoBrowOpacity?: number;
}

export class VTOActionUseCase {
    private eventRepository: EventRepository;
    private event: string;
    private vtoType: string;
    private eventValue?: number;
    private vtoItemId?: string;
    private vtoLookIndex?: number;
    private vtoLookId?: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private vtoBrowGoals?: any[];
    private vtoBrowShape?: string;
    private vtoBrowSkuId?: string;
    private vtoBrowLength?: string;
    private vtoBrowThickness?: string;
    private vtoBrowOpacity?: number;

    constructor(vtoAction: IVtoAction) {
        const {
            event,
            vtoType = '',
            eventValue = 0,
            vtoItemId = '',
            vtoLookIndex = 0,
            vtoLookId = '',
            vtoBrowGoals = [],
            vtoBrowShape = '',
            vtoBrowSkuId = '',
            vtoBrowLength = '',
            vtoBrowThickness = '',
            vtoBrowOpacity = 0
        } = vtoAction;

        this.eventRepository = diContainer.get(serviceNames.eventRepository);
        this.event = event;
        this.vtoType = vtoType;
        this.eventValue = eventValue;
        this.vtoItemId = vtoItemId;
        this.vtoLookIndex = vtoLookIndex;
        this.vtoLookId = vtoLookId;
        this.vtoBrowGoals = vtoBrowGoals;
        this.vtoBrowShape = vtoBrowShape;
        this.vtoBrowSkuId = vtoBrowSkuId;
        this.vtoBrowLength = vtoBrowLength;
        this.vtoBrowThickness = vtoBrowThickness;
        this.vtoBrowOpacity = vtoBrowOpacity;
    }

    public execute = () => {
        const vtoActionPayload = {
            event_name: 'vto',
            event_category: 'vto',
            event_action: this.event,
            event_label: 'event',
            ...(this.eventValue && { event_value: this.eventValue }),
            modiface_evar: `YouCam |  ${this.event}  | event`,
            vendor: 'youcam',
            vto_type: this.vtoType,
            ...(this.vtoItemId && { vto_item_id: this.vtoItemId }),
            ...(this.vtoLookIndex && { vto_look_index: this.vtoLookIndex }),
            ...(this.vtoLookId && { vto_look_id: this.vtoLookId }),
            ...(this.vtoBrowGoals?.length && { vto_brow_goals: this.vtoBrowGoals }),
            ...(this.vtoBrowShape && { vto_brow_shape: this.vtoBrowShape }),
            ...(this.vtoBrowSkuId && { vto_brow_sku_id: this.vtoBrowSkuId }),
            ...(this.vtoBrowLength && { vto_brow_length: this.vtoBrowLength }),
            ...(this.vtoBrowThickness && { vto_brow_thickness: this.vtoBrowThickness }),
            ...(this.vtoBrowOpacity && { vto_brow_opacity: this.vtoBrowOpacity })
        };

        const newEvent = new Event({
            id: this.eventRepository.generateId(),
            name: this.event,
            type: 'link',
            payload: vtoActionPayload
        });

        this.eventRepository.addEventToQueue(newEvent);
    };
}
